<template>
	<div class="menus-wrap">
		<head-info style="margin-bottom: 50px;"></head-info>
		<div id="print-wrap">
			<div class="print">
				<h1 v-if="detail.erj1">{{ detail.erj1 || '-' }}</h1>
				<h1 v-if="detail.erj2">{{ detail.erj2 || '-' }}</h1>
				<h1 v-else>{{ detail.examination_name || '-' }}准考证</h1>
				<p class="slider"></p>
				<div class="main">
					<ul class="info">
						<li>姓名：{{ detail.name }}</li>
						<!--<li>性别：{{ detail.gender && detail.gender === 1 ? '男' : detail.gender && detail.gender === 2 ? '女' : '-' }}</li>-->
						<li>身份证号：{{ detail.card_id || '-' }}</li>
						<li>报考单位：{{ detail.department || '-' }}</li>
						<li>报考岗位：{{ detail.position || '-' }}</li>
						<li>考点名称：{{ detail.site_name || '-' }}</li>
						<li>考点地址：{{ detail.site_address || '-' }}</li>
						<li>准考证号：{{ detail.number || '-' }}
							<span style="margin-left: 20px;">考场号：{{ detail.room || '-' }}</span>
							<span style="margin-left: 20px;">座位号：{{ detail.seat || '-' }}</span>
						</li>
						<li v-if="detail.classify">考试类别：{{ detail.classify }}</li>
					</ul>
					<template v-if="detail.photo">
						<el-image style="width: 100px; height: 140px;background-color: #f5f7fa;line-height: 140px;" fit="contain" :src="detail.photo" :preview-src-list="[detail.photo]">
							<div slot="error" style="text-align: center;"><i style="font-size: 30px;" class="el-icon-picture-outline"></i></div>
						</el-image>
					</template>
				</div>
				<template v-if="detail.seat">
					<p class="table-title">考试科目及时间：</p>
					<!-- 
						<el-table :data="detail.subject" :span-method="objectSpanMethod" border :header-cell-style="{ backgroundColor: '#fff' }">
					 -->
					 <el-table :data="detail.subject" border :header-cell-style="{ backgroundColor: '#fff' }">
						<el-table-column prop="subject_name" label="考试科目" align="center"></el-table-column>
						<el-table-column prop="start_time" label="考试日期" width="200" align="center"></el-table-column>
						<el-table-column prop="end_time" label="考试时间" width="200" align="center"></el-table-column>
					</el-table>
				</template>
				<!--<template v-else>
					<div style="height:48px; border: 1px solid #000000; text-align: center; vertical-align: middle;padding-top:20px;font-weight:bold">因为未达到规定比例，直接进入面试</div>
				</template>-->
				<div v-html="detail.points"></div>
			</div>
		</div>
		<div v-if="mobile === 0" class="footer-btns"><el-button type="primary" v-print="printObj">点击打印</el-button></div>
		<div v-else class="footer-btns"><el-button type="primary" @click="downloadClick">点击下载</el-button></div>
	</div>
</template>

<script>
import HeadInfo from '@/components/HeadInfo';
import { reqGetPrintCandidateInfo, reqGetExplain, reqPrintCandidate } from '@/api';
import { Message } from 'element-ui';
import {mapGetters,mapState} from "vuex";
import html2Canvas from 'html2canvas';
import JsPDF from 'jspdf';
import store from '@/store';
export default {
	components: {
		HeadInfo
	},
	data() {
		return {
			detail: {},
			explain: '',
			status: false,
			printObj: {
				id: 'print-wrap',
				openCallback() {
					reqPrintCandidate();
				}
			}
		};
	},
	computed: {
		verify() {
			try {
				return this.detail.verify === 1 ? '未审核' : this.detail.verify === 2 ? '未通过' : this.detail.verify === 3 ? '已通过' : '-';
			} catch (e) {
				//TODO handle the exception
				return '-';
			}
		},
		...mapState({
			mobile: state => state.system.mobile,
			user_id: state => state.user.examinee.id,
		}),
		...mapGetters('user',['GET_USER_INFO']),
	},
	beforeRouteEnter(to, form, next) {
		reqGetPrintCandidateInfo().then(res => {
			if (res.data.print_before) {
				Message.info('打印准考证时间未到');
				next(false);
			} else if (res.data.print_open) {
				if (res.data.site_name) {
					next(vm => {
						vm.detail = vm.GET_USER_INFO;
						Object.assign(vm.detail,res.data);
					});
				} else {
					Message.info('暂未设置考场');
					next(false);
				}
			} else if (res.data.print_end) {
				Message.info('打印准考证时间已过');
				next(false);
			}
		});
	},
	methods: {
		 downloadClick() {
		      var title = `${this.detail.name}-${this.detail.examination_name}准考证`;
		      html2Canvas(document.querySelector('#print-wrap'), {
			allowTaint: true,
			    scale: 2,
			    dpi: 600,//导出pdf清晰度
			    useCORS: true
		      }).then(function (canvas) {
			var pdf = new JsPDF('p', 'mm', 'a4');    //A4纸，纵向
			var ctx = canvas.getContext('2d'),
			  a4w = 190, a4h = 277,    //A4大小，210mm x 297mm，四边各保留10mm的边距，显示区域190x277
			  imgHeight = Math.floor(a4h * canvas.width / a4w),    //按A4显示比例换算一页图像的像素高度
			  renderedHeight = 0;
		 
			while (renderedHeight < canvas.height) {
			  var page = document.createElement("canvas");
			  page.width = canvas.width;
			  page.height = Math.min(imgHeight, canvas.height - renderedHeight);//可能内容不足一页
		 
			  //用getImageData剪裁指定区域，并画到前面创建的canvas对象中
			  page.getContext('2d').putImageData(ctx.getImageData(0, renderedHeight, canvas.width, Math.min(imgHeight, canvas.height - renderedHeight)), 0, 0);
			  pdf.addImage(page.toDataURL('image/jpeg', 1.0), 'JPEG', 10, 10, a4w, Math.min(a4h, a4w * page.height / page.width));    //添加图像到页面，保留10mm边距
			  renderedHeight += imgHeight;
			  if (renderedHeight < canvas.height)
			    pdf.addPage();//如果后面还有内容，添加一个空页
			  // delete page;
			}
			reqPrintCandidate();
			pdf.save(title + '.pdf');
		      });
		    },
		objectSpanMethod({ row, column, rowIndex, columnIndex }) {
			if (columnIndex !== 0) {
				if (rowIndex % 2 === 0) {
					return {
						rowspan: 2,
						colspan: 1
					};
				} else {
					return {
						rowspan: 0,
						colspan: 0
					};
				}
			}
		}
	}
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/color.scss';
#print-wrap {
	max-width: 700px;
	margin: 0 auto;
	border: 1px solid #333;
}
.print {
	color: #000;
	border: 1px solid #333;
	padding: 10px 30px;
	margin: 2px;

	.page_print {
		page-break-after:always;
	}
	h1 {
		font-size: 18px;
		text-align: center;
		margin: 0 auto;
	}
	h2 {
		font-size: 16px;
		text-align: center;
		margin: 0 auto;
	}
	.slider {
		border-top: 1px solid #333;
		margin-top: 10px;
	}
	.main {
		margin-top: 15px;
		display: flex;
		justify-content: space-between;
		.info {
			font-size: 14px;
			font-weight: 500;
			color: #1a222e;
			width: 530px;

			li {
				line-height: 19px;
			}
		}
		img {
			flex-shrink: 0;
			max-width: 100px;
			max-height: 140px;
			object-fit: contain;
		}
	}
	.table-title {
		font-size: 14px;
		margin-top: 15px;
	}
	::v-deep .el-table {
		margin-top: 10px;
		border: 1px solid #000000;
		border-right: 2px solid #000000;
		border-bottom: 2px solid #000000;
		.cell {
			line-height: 16px;
		}

		.el-table__cell {
			color: #000;
			border: 1px solid #000000;
		}
	}
	h3 {
		letter-spacing: 8px;
		text-align: center;
		font-size: 16px;
		color: #000000;
		margin-top: 15px;
		margin-bottom: 20px;
	}
}
</style>
